module.exports = __webpack_public_path__ + "KIA-logo.png";